import { render, staticRenderFns } from "./ScalarPlot.vue?vue&type=template&id=6ebb0326"
import script from "./ScalarPlot.vue?vue&type=script&lang=js"
export * from "./ScalarPlot.vue?vue&type=script&lang=js"
import style0 from "./ScalarPlot.vue?vue&type=style&index=0&id=6ebb0326&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports